import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { TemplateService } from '../../../../../common/services/Template.service';
import { BsModalService } from 'ngx-bootstrap';
import { GroupService } from '../../../../../common/services/Group.service';
import * as _ from 'lodash';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { UserService } from '../../../../../common/services/User.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.css'],
  providers: [TemplateService, BsModalService, GroupService, PriorityService, TicketService, UserService],
})
@Injectable()
export class TicketComponent implements OnInit {
  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public accessTypes: any = [];
  public allGroup: any = [];
  public model: any = {};
  public modelFilter: any = {};
  public typeModal = 'add';
  public modalRef: any = {};
  public modalRef2: any = {};
  public is_load_data = true;
  totalItem: any = 0;
  totalPage: any = 0;
  public tab = 'template';

  public user: any;
  public id_delete: number;
  public access_type: any;
  public options: any = [];
  public number = 0;
  public myOptions: any = [];
  public row: any = [];
  public arr: any = [];

  public allPriority: any = [];
  public allStatus: any = [];
  public allUser: any = [];
  public access_ids: any = [];

  public subject: any;
  public intro: any;

  constructor(
    private templateService: TemplateService,
    private modalService: BsModalService,
    private priorityService: PriorityService,
    private ticketService: TicketService,
    private userService: UserService,
    private groupService: GroupService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    // this.options = [
    //     {
    //         text: 'Tiêu đề',
    //         id: 'subject',
    //         disable : false
    //     },
    //     {
    //         text: 'Mô tả',
    //         id: 'intro',
    //         disable : false
    //     },
    //     {
    //         text: 'Chuyên viên',
    //         id: 'assign',
    //         disable : false
    //     },
    //     {
    //         text: 'Cc',
    //         id: 'cc',
    //         disable : false
    //     },
    //     {
    //         text: 'Theo dõi',
    //         id: 'follow',
    //         disable : false
    //     },
    //     {
    //         text: 'Ưu tiên',
    //         id: 'priority',
    //         disable : false
    //     },
    //     {
    //         text: 'Trạng thái',
    //         id: 'status',
    //         disable : false
    //     }
    // ]
    // this.row[this.number] = true;
    // this.arr.push(this.number);
    // this.number++

    // for(let i=0; i<7; i++) {
    //     this.arr.push(i);
    // }
  }

  ngOnInit() {
    this.loadData();
  }

  loadData(request = {}) {
    switch (this.tab) {
      case 'template': {
        this.loadTemplate(request);
        break;
      }
      default:
        break;
    }
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ filters: this.modelFilter.keyword.trim() });
    } else {
      this.loadData();
    }
  }

  loadTemplate(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.templateService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.list = res.data.templates;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
        }
      );
  }

  addTemplate() {
    console.log(this.model);
    if (!this.model.name || this.model.name.trim() == '') {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên mẫu trả lời không được bỏ trống !',
      };
    } else if (!this.model.access_type) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Đối tượng sử dụng không được bỏ trống !',
      };
    } else if (
      this.model.access_type == 'group-agent' &&
      (!this.model.access_ids || this.model.access_ids.length == 0)
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Bộ phận sử dụng không được bỏ trống !',
      };
    } else if (
      !this.model.subject &&
      !this.model.intro &&
      (!this.model.follow || this.model.follow == -1) &&
      (!this.model.cc || this.model.cc == -1) &&
      (!this.model.assign || this.model.assign == -1) &&
      (!this.model.priority || this.model.priority == -1) &&
      (!this.model.status || this.model.status == -1)
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Yêu cầu chọn ít nhất 1 hành động!',
      };
    } else {
      // this.options.forEach(e => {
      //     delete this.model[e.id];
      // });
      // this.myOptions.forEach(e => {
      //     if(e.key && e.value) {
      //         this.model[e.key] = e.value;
      //     }else if(e.key && !e.value){
      //         delete this.model[e.key];
      //     }
      // });
      // if(this.subject) this.model['subject'] = this.subject;
      // if(this.intro) this.model['intro'] = this.intro;
      this.templateService.create(this.model).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Lưu không thành công',
              };
              this.toastr.error('Lưu không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Cập nhật thành công',
              };
              this.toastr.success('Cập nhật thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });

              this.loadData();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
    setTimeout(() => {
      this.message = null;
    }, 3000);
  }

  editTemplate() {
    console.log(this.model);
    if (!this.model.name || this.model.name.trim() == '') {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên mẫu trả lời không được bỏ trống !',
      };
    } else if (!this.model.access_type) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Đối tượng sử dụng không được bỏ trống !',
      };
    } else if (
      this.model.access_type == 'group-agent' &&
      (!this.model.access_ids || this.model.access_ids.length == 0)
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Bộ phận sử dụng không được bỏ trống !',
      };
    } else if (
      !this.model.subject &&
      !this.model.intro &&
      (!this.model.follow || this.model.follow == -1) &&
      (!this.model.cc || this.model.cc == -1) &&
      (!this.model.assign || this.model.assign == -1) &&
      (!this.model.priority || this.model.priority == -1) &&
      (!this.model.status || this.model.status == -1)
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Yêu cầu chọn ít nhất 1 hành động!',
      };
    } else {
      // this.options.forEach(e => {
      //     delete this.model[e.id];
      // });
      // console.log(this.myOptions);
      // this.myOptions.forEach(e => {
      //     if(e.key && e.value) {
      //         this.model[e.key] = e.value;
      //     }else if(e.key && !e.value){
      //         this.model[e.key] = null;
      //     }
      // });

      // this.model['subject'] = this.subject;
      // this.model['intro'] = this.intro;

      const id = this.model._id;
      delete this.model._id;
      this.templateService.update(id, this.model).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Lưu không thành công',
              };
              this.toastr.error('Lưu không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Cập nhật thành công',
              };
              this.toastr.success('Cập nhật thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });

              this.loadData();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
    setTimeout(() => {
      this.message = null;
    }, 3000);
  }
  getAccessTypes() {
    this.accessTypes = [
      {
        text: '--chọn đối tượng sử dụng',
        id: '',
      },
      {
        text: 'Tất cả các chuyên viên',
        id: 'all-agent',
      },
      {
        text: 'Chuyên viên thuộc bộ phận',
        id: 'group-agent',
      },
      {
        text: 'Chỉ mình bạn',
        id: 'only-me',
      },
    ];
  }

  getGroups() {
    this.groupService.list({ limit: 500 }).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.allGroup = res.data.list;
        this.allGroup = _.map(this.allGroup, e => {
          return {
            text: e['name'],
            id: e['id'],
          };
        });
      } else {
        this.allGroup = [];
      }
    });
  }

  changedType($event) {
    if (!this.is_load_data) {
      this.access_type = $event.value;
      this.model['access_type'] = $event.value;
      if ($event.value == 'group-agent') {
        this.getGroups();
      } else if ($event.value == 'only-me') {
        this.model['access_ids'] = [
          {
            id: this.user._id,
            label: this.user.name,
          },
        ];
      } else if ($event.value == 'all-agent') {
        this.model['access_ids'] = null;
      }
    }
  }

  onChange(value, number) {
    let old_value = null;
    if (this.myOptions[number]) {
      this.myOptions[number]['value'] = null;
      old_value = this.myOptions[number].key;
      if (old_value == 'subject') {
        this.subject = null;
      }
      if (old_value == 'intro') {
        this.intro = null;
      }
    }
    this.myOptions[number] = {
      key: value,
    };
    this.options = _.map(this.options, e => {
      if (e.id == value) {
        e.disable = true;
      }
      if (e.id == old_value) {
        e.disable = false;
      }
      return e;
    });
  }

  // addOption() {
  //     console.log(this.arr);

  //         let check = _.find(this.options, {disable: false});
  //         if(check) {
  //             // this.row[this.number] = true;
  //             this.arr.push(true);
  //         }
  //         // this.number = this.number + 1;

  // }

  // deleteOption(i) {
  //     console.log(i);
  //     // this.row[i]= false;
  //     this.arr.splice(i,1);
  //     console.log(this.arr);
  //     if(this.myOptions[i]) {
  //         if(this.myOptions[i].key == 'subject') {
  //             this.subject = null;
  //         }else if(this.myOptions[i].key == 'intro') {
  //             this.intro = null;
  //         }
  //         this.myOptions[i].value = null;

  //     }
  //     this.options = _.map(this.options, e=> {
  //         if(this.myOptions[i] && e.id == this.myOptions[i].key) {
  //             e.disable = false
  //         }
  //         return e;
  //     })

  //     // this.number -= 1;
  // }

  changedValue($event, type, i) {
    if (!this.is_load_data) {
      this.myOptions[i] = {
        key: type,
        value: $event.value,
      };
    }
  }

  changedFollow($event) {
    if (!this.is_load_data) {
      this.model.follow = $event.value;
    }
  }

  changedAssign($event) {
    if (!this.is_load_data) {
      this.model.assign = $event.value;
    }
  }

  changedCC($event) {
    if (!this.is_load_data) {
      this.model.cc = $event.value;
    }
  }

  changedPriority($event) {
    if (!this.is_load_data) {
      this.model.priority = $event.value;
    }
  }

  changedStatus($event) {
    if (!this.is_load_data) {
      this.model.status = $event.value;
    }
  }

  changedAccessGroup($event) {
    if (!this.is_load_data) {
      const access_ids = [];
      $event.data.forEach(e => {
        access_ids.push({
          id: e.id,
          label: e.text,
        });
      });
      this.model['access_ids'] = access_ids;
    }
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.model = {};
    this.access_type = null;
    this.message = null;
    this.access_ids = [];
    this.is_load_data = true;
    this.getAccessTypes();
    this.getPriorities();
    this.getStatus();
    this.getAgents();
    this.myOptions = [];
    this.typeModal = id ? 'edit' : 'add';
    if (id) {
      // this.row[0] = this.row[1] = this.row[2] = this.row[3] = this.row[4] = this.row[5]= this.row[6] = false;
      this.templateService
        .find(id)
        .toPromise()
        .then(rs => {
          this.model = rs.data;
          this.access_type = this.model.access_type;
          if (this.model.access_ids) {
            this.access_ids = _.map(this.model.access_ids, e => {
              return e.id;
            });
          }
          //     let choice = [];
          //     if(this.model.subject) {
          //         this.myOptions.push({
          //             key: 'subject',
          //             value: this.model.subject
          //         });
          //         this.subject = this.model.subject;
          //         this.row[this.number] = true;
          //         choice['subject'] = true;
          //         this.number++;
          //     }
          //     if(this.model.intro) {
          //         this.myOptions.push({
          //             key: 'intro',
          //             value: this.model.intro
          //         })
          //         this.intro = this.model.intro;
          //         this.row[this.number] = true;
          //         choice['intro'] = true;
          //         this.number++;
          //     }

          //     if(this.model.assign) {
          //         this.myOptions.push({
          //             key: 'assign',
          //             value: this.model.assign
          //         })
          //         choice['assign'] = true;
          //         this.row[this.number] = true;
          //         this.number++;
          //     }
          //     if(this.model.cc) {
          //         this.myOptions.push({
          //             key: 'cc',
          //             value: this.model.cc
          //         })
          //         choice['cc'] = true;
          //         this.row[this.number] = true;
          //         this.number++;
          //     }
          //     if(this.model.follow) {
          //         this.myOptions.push({
          //             key: 'follow',
          //             value: this.model.follow
          //         })
          //         choice['follow'] = true;
          //         this.row[this.number] = true;
          //         this.number++;
          //     }

          //     if(this.model.status) {
          //         this.myOptions.push({
          //             key: 'status',
          //             value: this.model.status
          //         })
          //         choice['status'] = true;
          //         this.row[this.number] = true;
          //         this.number++;
          //     }
          //     if(this.model.priority) {
          //         this.myOptions.push({
          //             key: 'priority',
          //             value: this.model.priority
          //         })
          //         choice['priority'] = true;
          //         this.row[this.number] = true;
          //         this.number++;
          //     }
          //     if(this.number == 0){
          //         this.arr = [];
          //         this.options = _.map(this.options, e => {
          //             e.disable = false;
          //             return e;
          //         })
          //         this.arr.push(this.number);
          //         this.row[this.number] = true;
          //         this.number++;
          //     }
          //     // console.log(this.myOptions, this.model, choice);
          //     this.options = _.map(this.options, e => {
          //         e.disable = choice[e.id] ? true : false;
          //         return e;
          //     })
        });
    }
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.modalRef = this.modalService.show(template, config);
    setTimeout(() => {
      this.is_load_data = false;
    }, 1000);
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.templateService._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    );
  }

  getAgents() {
    this.userService.all().subscribe(res => {
      const userList = [
        {
          text: '--Chọn--',
          id: '-1',
        },
        {
          text: '',
          id: '',
        },
        {
          text: 'Chuyên viên đang xử lý',
          id: '[current-agent]',
        },
      ];
      res.data.list.forEach((c: any) => {
        userList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.allUser = userList;
    });
  }
  getPriorities() {
    this.priorityService.allPriority().subscribe(res => {
      const priorityList = [
        {
          text: '--Chọn--',
          id: '-1',
        },
        {
          text: '',
          id: '',
        },
      ];
      res.data.forEach((c: any) => {
        priorityList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allPriority = priorityList;
    });
  }

  getStatus() {
    this.ticketService.status().subscribe(res => {
      const statusList = [
        {
          text: '--Chọn--',
          id: '-1',
        },
        {
          text: '',
          id: '',
        },
      ];
      res.data.forEach((c: any) => {
        statusList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allStatus = statusList;
    });
  }

  changeTab(tab) {
    this.tab = tab;
    this.loadData();
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/ticket/ticket.component.ts